import { mapActions, mapState } from "vuex";

/**
 * Mixin: manejo de países por empresa.
 * - Expone `country_id` (seleccionado) y `allCountries` (lista desde store).
 * - Provee `loadCountries(companyId)` para cargar países por empresa.
 */
export default {
  data() {
    return {
      country_id: null,
    };
  },
  computed: {
    ...mapState("configurableVariables", ["allCountries"]),
  },
  methods: {
    ...mapActions("configurableVariables", ["getAllCountriesByCompany"]),

    async loadCountries(companyId) {
      this.country_id = null;
      if (!companyId) return;
      await this.getAllCountriesByCompany(companyId);
    },
  },
};


